module.exports = __webpack_public_path__ + "img/icon-06.f252e103.png";